import { render, staticRenderFns } from "./CmgHero.vue?vue&type=template&id=42c9fca6&scoped=true&lang=pug"
import script from "./cmg-hero.ts?vue&type=script&lang=ts&external"
export * from "./cmg-hero.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgHero.vue?vue&type=style&index=0&id=42c9fca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c9fca6",
  null
  
)

export default component.exports